import { onMounted } from 'vue';
import { useSeonApi } from '../../../../api/seon-api';
import Cookie from 'js-cookie';
import { COOKIE_PORTAL_ID_NAME } from '../../constants/constants';

const portalIdSanitized = Cookie.get(COOKIE_PORTAL_ID_NAME)?.replace(/-/g, '');
const { getSession: getExtendedSession, postSession } = useSeonApi(portalIdSanitized);

const init = () => {
	if (!portalIdSanitized) return;

	if (window.seon?.init) {
		try {
			window.seon.init();
			console.log('SEON init success');
		} catch (err) {
			console.error('SEON init failed:', err);
		}
	}
};

const getSession = async () => {
	if (!window.seon?.getSession) {
		console.warn('SEON SDK not ready.');
		return null;
	}

	try {
		const session = await window.seon.getSession({
			fieldTimeoutMs: 2000,
			networkTimeoutMs: 2000,
			region: 'eu'
		});
		if (session) {
			try {
				await postSession(session);
				const { data } = await getExtendedSession();
				return data;
			} catch (error) {
				console.error('Error fetching extended session:', error);
				return session;
			}
		}
	} catch (error) {
		console.error('Error fetching base64 session:', error);
	}
	return null;
};

export const useSeon = () => {
	onMounted(() => {
		init();
	});

	return {
		getSession
	};
};
